import { render, staticRenderFns } from "./PurchaseFish.vue?vue&type=template&id=276a24fa&scoped=true"
import script from "./PurchaseFish.vue?vue&type=script&setup=true&lang=ts"
export * from "./PurchaseFish.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./PurchaseFish.vue?vue&type=style&index=0&id=276a24fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "276a24fa",
  null
  
)

export default component.exports